import { lazy } from 'react';
/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   const HomePage = lazy(() => import('./pages/HomePage'));
 *   const Dashboard = lazy(() => import('./pages/Dashboard'));
 *   const Settings = lazy(() => import('./pages/Settings'));
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   const Home = lazy(() => import('./pages/Home'));
 *   const Settings = lazy(() => import('./pages/Settings'));
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
const Automations = lazy(() => import('./pages/Automations'));
const Devices = lazy(() => import('./pages/Devices'));
const Integraciones = lazy(() => import('./pages/Integraciones'));
const GMBHealthScore = lazy(() => import('./pages/GMBHealthScore'));
const GMBGeoGrid = lazy(() => import('./pages/GMBGeoGrid'));
const GMBMetrics = lazy(() => import('./pages/GMBMetrics'));
const GMBProfile = lazy(() => import('./pages/GMBProfile'));
const GMBPublications = lazy(() => import('./pages/GMBPublications'));
const GbusinessConnect = lazy(() => import('./pages/GbusinessConnect'));
const GbusinessSettings = lazy(() => import('./pages/GbusinessSettings'));
const Home = lazy(() => import('./pages/Home'));
// `Landing` y `Pricing` eran de la V2 y se borraron. Este fichero es
// autogenerado y su cabecera pide no tocar PAGES a mano, pero el generador solo
// añade: con sus `lazy(() => import(...))` apuntando a ficheros que ya no
// existen, el build no pasa de la primera línea.
const LinkTreeConfig = lazy(() => import('./pages/LinkTreeConfig'));
const MyBusiness = lazy(() => import('./pages/MyBusiness'));
const Redirect = lazy(() => import('./pages/Redirect'));
const LinkTree = lazy(() => import('./pages/LinkTree'));
const ReportsInformes = lazy(() => import('./pages/ReportsInformes'));
const ReportsKeywords = lazy(() => import('./pages/ReportsKeywords'));
const ReportsNPS = lazy(() => import('./pages/ReportsNPS'));
const ReportsSentiment = lazy(() => import('./pages/ReportsSentiment'));
const Reviews = lazy(() => import('./pages/Reviews'));
const SettingsNotifications = lazy(() => import('./pages/SettingsNotifications'));
const SettingsOrganization = lazy(() => import('./pages/SettingsOrganization'));
const SuggestFeatures = lazy(() => import('./pages/SuggestFeatures'));
const Register = lazy(() => import('./pages/Register'));
const PasswordReset = lazy(() => import('./pages/PasswordReset'));
const ScanQR = lazy(() => import('./pages/ScanQR'));
const RegisterQR = lazy(() => import('./pages/RegisterQR'));
const ProductDetail = lazy(() => import('./pages/ProductDetail'));
const Profile = lazy(() => import('./pages/Profile'));
const ProductUpdate = lazy(() => import('./pages/ProductUpdate'));
const Analytics = lazy(() => import('./pages/Analytics'));
const AdminUsers = lazy(() => import('./pages/AdminUsers'));
const AdminProducts = lazy(() => import('./pages/AdminProducts'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminMetrics = lazy(() => import('./pages/AdminMetrics'));
const AdminAlerts = lazy(() => import('./pages/AdminAlerts'));
// TEMPORAL (decisiones §152): borrar al pasar la protección de ficha a live.
const AdminProtectionReview = lazy(() => import('./pages/AdminProtectionReview'));
const AdminLeads = lazy(() => import('./pages/AdminLeads'));
const AdminScoreboard = lazy(() => import('./pages/AdminScoreboard'));
const AdminCampanaGoogleBusiness = lazy(() => import('./pages/AdminCampanaGoogleBusiness'));
const AdminCampanaPt = lazy(() => import('./pages/AdminCampanaPt'));
const AdminProspeccion = lazy(() => import('./pages/AdminProspeccion'));
const AdminIncludedDevices = lazy(() => import('./pages/AdminIncludedDevices'));
const AdminMeetings = lazy(() => import('./pages/AdminMeetings'));
const AdminMap = lazy(() => import('./pages/AdminMap'));
const AdminBulkProducts = lazy(() => import('./pages/AdminBulkProducts'));
const AdminCtaLinks = lazy(() => import('./pages/AdminCtaLinks'));
const AdminDemoAccounts = lazy(() => import('./pages/AdminDemoAccounts'));
const AdminInformeMapa = lazy(() => import('./pages/AdminInformeMapa'));
const AdminPlaceIds = lazy(() => import('./pages/AdminPlaceIds'));
const AdminGmb = lazy(() => import('./pages/AdminGmb'));
const AdminSettings = lazy(() => import('./pages/AdminSettings'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));
const SelectLocation = lazy(() => import('./pages/SelectLocation'));
const EmployeeRanking = lazy(() => import('./pages/EmployeeRanking'));
const LocalesCompare = lazy(() => import('./pages/LocalesCompare'));
const LocationDetail = lazy(() => import('./pages/LocationDetail'));

/*
 * `Layout` en DIFERIDO, como las páginas.
 *
 * Era el único `import` estático de este fichero, y como `App.jsx` importa
 * `pages.config.js`, todo el árbol del Layout acababa en el chunk de entrada —
 * el que descarga también un visitante anónimo que solo va a ver la landing.
 * Y el árbol no es pequeño: `api/gbusinessService` (102 KB, el segundo módulo
 * de `src/` más grande del bundle), `components/ui/sidebar`, `useProducts`,
 * `useOnboarding`, `SeatChoiceModal` y, por la cadena, `AuthContext`.
 *
 * Es el chrome del panel: no se pinta nunca sin sesión iniciada, así que el
 * `<Suspense>` que ya envuelve todas las rutas se encarga, y quien tiene sesión
 * lo pide una vez.
 */
const __Layout = lazy(() => import('./Layout.jsx'));


export const PAGES = {
    "Automations": Automations,
    "Devices": Devices,
    "Integraciones": Integraciones,
    "GMBHealthScore": GMBHealthScore,
    "GMBGeoGrid": GMBGeoGrid,
    "GMBMetrics": GMBMetrics,
    "GMBProfile": GMBProfile,
    "GMBPublications": GMBPublications,
    "GbusinessConnect": GbusinessConnect,
    "settings": GbusinessSettings,
    "Home": Home,
    "LinkTreeConfig": LinkTreeConfig,
    "MyBusiness": MyBusiness,
    "Redirect": Redirect,
    "LinkTree": LinkTree,
    "ReportsInformes": ReportsInformes,
    "ReportsKeywords": ReportsKeywords,
    "ReportsNPS": ReportsNPS,
    "ReportsSentiment": ReportsSentiment,
    "Reviews": Reviews,
    "SettingsNotifications": SettingsNotifications,
    "SettingsOrganization": SettingsOrganization,
    "SuggestFeatures": SuggestFeatures,
    "Register": Register,
    "PasswordReset": PasswordReset,
    "ScanQR": ScanQR,
    "RegisterQR": RegisterQR,
    "ProductDetail": ProductDetail,
    "Profile": Profile,
    "ProductUpdate": ProductUpdate,
    "Analytics": Analytics,
    "AdminUsers": AdminUsers,
    "AdminProducts": AdminProducts,
    "AdminDashboard": AdminDashboard,
    "AdminMetrics": AdminMetrics,
    "AdminAlerts": AdminAlerts,
    "AdminProtectionReview": AdminProtectionReview,
    "AdminLeads": AdminLeads,
    "AdminScoreboard": AdminScoreboard,
    "AdminCampanaGoogleBusiness": AdminCampanaGoogleBusiness,
    "AdminCampanaPt": AdminCampanaPt,
    "AdminProspeccion": AdminProspeccion,
    "AdminIncludedDevices": AdminIncludedDevices,
    "AdminMeetings": AdminMeetings,
    "AdminMap": AdminMap,
    "AdminBulkProducts": AdminBulkProducts,
    "AdminCtaLinks": AdminCtaLinks,
    "AdminDemoAccounts": AdminDemoAccounts,
    "AdminInformeMapa": AdminInformeMapa,
    "AdminPlaceIds": AdminPlaceIds,
    "AdminGmb": AdminGmb,
    "AdminSettings": AdminSettings,
    "Terms": Terms,
    "Privacy": Privacy,
    "SelectLocation": SelectLocation,
    "EmployeeRanking": EmployeeRanking,
    "LocalesCompare": LocalesCompare,
    "LocationDetail": LocationDetail,
}

export const pagesConfig = {
    mainPage: "Devices",
    Pages: PAGES,
    Layout: __Layout,
};